export const WhatsAppTestingMutation = (builder) => ({
    WhatsAppTesting: builder.mutation({
      query: (credentials) => {
        const token = JSON.parse(localStorage.getItem('TOKEN'))?.token || '';
        return {
          url: '/send_whatsapp',
          method: 'POST',
          body: credentials,
          headers: {
            'Content-Type': 'application/json',
            'Authorization': token 
          },
        };
      },
    }),
  });